import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FloatLabel } from '../float-label';
import { RequiredIndicator } from '../required-indicator';
import style from './float-currency-input.module.less';

export class FloatCurrencyInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      slideLabelUp: props.value != null,
      focused: false,
    };
  }

  onClick = () => {
    this.setState({
      slideLabelUp: true,
      focused: true,
    });
    this.input.focus();
  };

  onFocus = () => {
    this.setState({
      slideLabelUp: true,
      focused: true,
    });
  };

  onBlur = (e) => {
    this.setState({
      slideLabelUp: !!e.target.value,
      focused: false,
    });
  };

  render() {
    const {
      value,
      label,
      onChange,
      currencySymbol = '',
      currencyOrientation = 'left',
      hasError = false,
      required = false,
      disabled = false,
    } = this.props;
    const { slideLabelUp, focused } = this.state;
    const className = classnames(
      style['float-currency-input'],
      { [style.focused]: focused },
      { [style.error]: hasError },
      { [style.disabled]: disabled },
      this.props.className || '',
    );

    const inputContainerClasses = classnames(
      style['input-container'],
      { [style['symbol-right']]: currencyOrientation === 'right' },
      { [style.shown]: slideLabelUp },
      { [style.error]: hasError },
      [style.disabled],
    );
    return (
      <div className={className} onClick={this.onClick}>
        <FloatLabel disabled={disabled} hasError={hasError} labelText={label} slideUp={slideLabelUp} />
        {required && <RequiredIndicator className={style['required-indicator']} />}
        <div className={inputContainerClasses}>
          <div className={style.currency}>{currencySymbol}</div>
          <input
            ref={(el) => (this.input = el)}
            disabled={disabled}
            onBlur={this.onBlur}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            onFocus={this.onFocus}
            type='number'
            value={value}
          />
        </div>
      </div>
    );
  }
}

FloatCurrencyInput.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  currencySymbol: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  currencyOrientation: PropTypes.oneOf(['left', 'right']),
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  hasError: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};
